import { render, staticRenderFns } from "./AppDrawerUser.vue?vue&type=template&id=0beda046"
import script from "./AppDrawerUser.vue?vue&type=script&lang=js"
export * from "./AppDrawerUser.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../shared/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports